import type { TestingInstructionsTargetKind } from './types';

export type TestingControlsCopyScope =
  | 'application'
  | 'externalNetwork'
  | 'internalNetwork';

const COPY_SCOPE_BY_TARGET_KIND: Record<
  TestingInstructionsTargetKind,
  TestingControlsCopyScope
> = {
  'web-application': 'application',
  'ai-application': 'application',
  'external-network': 'externalNetwork',
  'internal-network': 'internalNetwork',
};

export const toTestingControlsCopyScope = (
  targetKind: TestingInstructionsTargetKind,
): TestingControlsCopyScope => COPY_SCOPE_BY_TARGET_KIND[targetKind];
